import axios from "axios";

export const state = {
    investments: [],
};

export const getters = {
    investments: state => state.investments,
};

export const mutations = {
    setInvestments(state, newValue) {
        state.investments = newValue
    },
};

export const actions = {
    async fetchInvestments({ commit }) {
        await axios.get('/investments').then(res => {
            commit('setInvestments', res.data.investments)
        })
    },
};
